import { useContext } from 'react';
import { ConfiguratorDataContext } from './configurator-data.context';

export const useConfiguratorData = () => {
	const context = useContext(ConfiguratorDataContext);

	if (!context) {
		throw new Error(
			'Hook "useConfiguratorData" must be wrapped in "ConfiguratorDataProvider" component',
		);
	}

	return context;
};
